export default "__VITE_ASSET__dGjS7jzm__"